import React from "react";
const ConditionalViewFormField = ({ isViewMode, labelText, children }) => isViewMode ? React.createElement("p", null, labelText) : children;
export default ConditionalViewFormField;
